export default __webpack_public_path__ + "static/media/ic_cnote_40000.38b5dc95.svg";